import React from "react";

interface PopupModalProps {
  show: boolean;
  type: "success" | "error";
  message: string;
  icon: string; 
  onClose: () => void;
}

const PopupModal: React.FC<PopupModalProps> = ({
  show,
  type,
  message,
  icon,
  onClose,
}) => {
  if (!show) return null;

  return (
    <div className='fixed inset-0 flex items-center justify-center bg-black/40 z-50'>
      <div
        className='bg-white rounded-xl p-6 w-[90%] max-w-md text-center relative space-y-4 shadow-lg border border-gray-200
        transform transition-transform duration-300 scale-100 animate-fadeIn'
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className='absolute top-3 right-3 text-gray-400 hover:text-gray-600 text-xl'
        >
          &times;
        </button>

        {/* Icon */}
        <img src={icon} alt={type} className='w-16 h-16 mx-auto' />

        {/* Message */}
        <p className='text-xl text-gray-800'>{message}</p>
      </div>
    </div>
  );
};

export default PopupModal;
